import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLFlowManifest } from '../interfaces';
import { TpETLPipeline } from '../../interfaces';
import { importPipelineFromYaml } from '../../utils';
import { generateDashboardYaml, generateEntityYaml, generatePipelineYaml } from './pipeline-templates';
import { FORM_DATATYPES, promptAutoForm, TpAutoFormDef } from '../../../../components/auto-form-modal/AutoForm';

function promptDiseaseAndGene(): Promise<{ disease: string; gene: string }> {
  const form: TpAutoFormDef = {
    title: `Define the disease and gene you on which you want to run the case study:`,
    fields: [
      {
        id: 'disease',
        name: 'Disease',
        dataType: FORM_DATATYPES.STRING,
        startContent: '',
        required: true,
      },
      {
        id: 'gene',
        name: 'Gene',
        dataType: FORM_DATATYPES.STRING,
        startContent: '',
        required: true,
      },
    ],
  };

  return promptAutoForm(form).then((dataForm: any) => {
    return {
      disease: dataForm.disease,
      gene: dataForm.gene,
    };
  });
}

function getPipeline(): Promise<TpETLPipeline> {
  return promptDiseaseAndGene().then((inputText: { disease: string; gene: string }) => {
    return importPipelineFromYaml(generatePipelineYaml(inputText.disease, inputText.gene));
  });
}

export const manifestETLDiseaseGeneCaseStudy: TpETLFlowManifest = {
  id: 'DiseaseGeneCaseStudy',
  name: 'Disease-Gene Case Study',
  description:
    'Based on an input disease and gene, this flow will search for relevant publications on Pubmed and create a dashboard overview with all relevant Publications and associations between the gene and the disease.',
  icon: <FontAwesomeIcon icon={['fas', 'diagram-project']} />,
  getPipeline: getPipeline,
  dashboardTemplate: generateDashboardYaml(),
  entityTemplate: generateEntityYaml(),
};
